class Validation {
    constructor() {
        this.name = 'Validation';
        this.ruleKeys = ['required', 'maxLength', 'minLength', 'minSize', 'type', 'condition', 'min', 'max', 'pattern']
        this.utilFuncs = {
            isValidEmail: this.isValidEmail,
            isValidTel: this.isValidTel,
            isValidUrl: this.isValidUrl,
            isValidDate: this.isValidDate,
        }
    }

    isValidEmail(value) {
        let emailRegExp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        return emailRegExp.test(value);
    }

    isValidTel(value) {
        let telRegExp = new RegExp(/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/g)
        return telRegExp.test(value);
    }

    isValidUrl(value) {
        let urlRegExp   = new RegExp(/^(http:\/\/|https:\/\/)?(www.)?((?!-)[a-zA-Z0-9-]+)\.(com|info|org|net|biz|gov|edu|xyz|ca|fr|ch|au|in|jp|mx|no|br|se|es|de|cn|uk|eu|ru|nl|us|co|tr)(\.(ca|fr|ch|au|in|jp|mx|no|br|se|es|de|cn|uk|eu|ru|nl|us|co|tr))?$/ig)
        return urlRegExp.test(value);
    }

    isValidDate(value) {
        /*
        Valid Values:
            YYYY-MM-DD
            YYYY/MM/DD
            YYYY.MM.DD
            YYYY MM DD
            YYYY-MM-DDTXX:XX:XXZ
            YYYY/MM/DDTXX:XX:XXZ
            YYYY.MM.DDTXX:XX:XXZ
            YYYY MM DDTXX:XX:XXZ
        */
        let dateRegExp = /^((19|20|21)\d\d[- /.](0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])(T[012][0-3]:[0-5][0-9]:[0-5][0-9]Z))|(19|20|21)\d\d[- /.](0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])$/g;
        return dateRegExp.test(value);
    }

    isValidCreditCard(value) {
        if (/[^0-9-\s]+/.test(value)) return false;
        let nCheck = 0;
        let bEven = false;
        let newValue = value.replace(/\D/g, "");
    
        for (var n = newValue.length - 1; n >= 0; n--) {
            var cDigit = newValue.charAt(n),
                nDigit = parseInt(cDigit, 10);
    
            if (bEven && (nDigit *= 2) > 9) 
                nDigit -= 9;
    
            nCheck += nDigit;
            bEven = !bEven;
        }
    
        return nCheck % 10 == 0;
    }

    isValidCreditCardExpireDate(value) {
        let d           = new Date();
        let thisYear    = d.toLocaleDateString(undefined, { year  : '2-digit' });
        let thisMonth   = d.toLocaleDateString(undefined, { month : '2-digit' });
        
        let month = '', year = '';
        if(value.includes('/')) {
            [ month, year ] = value.split('/');
        } else {
            return false;
        }

        if (year === '')
            return false;

        if (parseInt(year) == parseInt(thisYear) && parseInt(month) < parseInt(thisMonth))
            return false;
            
        if (parseInt(year) >= parseInt(thisYear))
            return true;

        return false;
    }

    checkFieldError(rule, key, data, value) {
        if(key === 'required' && value.length === 0 && value !== 0) 
            return ({ type: key, message: 'Please fill out this field.' });

        if(key === 'maxLength' && value.length > rule[key])
            return ({ type: key, message: 'Please lengthen this text.' });

        if(key === 'minLength' &&  value.length < rule[key])
            return ({ type: key, message: 'Please shorten this text.' });

        if(key === 'minSize' && value.length < rule[key])
            return ({ type: key, message: 'Please enter at least one value.' });

        if(key === 'type' && value.length > 0) {
            if(rule[key] === 'email' &&  !this.isValidEmail(value))
                return ({ type: key, message: 'Please enter a valid email address.' });

            if(rule[key] === 'tel' &&  !this.isValidTel(value))
                return ({ type: key, message: 'Please enter a valid phone number.' });

            if(rule[key] === 'url' &&  !this.isValidUrl(value))
                return ({ type: key, message: 'Please enter a valid url.' });

            if(rule[key] === 'creditCardNumber' &&  !this.isValidCreditCard(value))
                return ({ type: key, message: 'Please enter a valid credit card number.' });

            if(rule[key] === 'creditCardExpireDate' &&  !this.isValidCreditCardExpireDate(value))
                return ({ type: key, message: 'Please enter a valid expire date.' });
            
            if(rule[key] === 'date' &&  !this.isValidDate(value))
                return ({ type: key, message: 'Please enter a valid date.' });
        }

        if(key === 'condition') {
            if(rule[key] instanceof Array) {
                let condErrors = [];
                rule[key].forEach(cond => {
                    if(cond['func'](data, value, this.utilFuncs))
                        return condErrors.push({ type: key, message: cond['message'] || 'Please check this field.' });
                });
                return condErrors.length > 0 ? condErrors : null;
            } else {
                if(rule[key]['func'](data, value, this.utilFuncs))
                    return ({ type: key, message: rule[key]['message'] || 'Please check this field.' });
            }
        }

        if(key === 'min' &&  value < rule[key]) 
            return ({ type: key, message: 'Please enter a larger value.' });

        if(key === 'max' &&  value > rule[key]) 
            return ({ type: key, message: 'Please enter a smaller value.' });

        if(key === 'pattern' &&  new RegExp(rule[key]).test(value))
            return ({ type: key, message: 'Please match the requested format.' });
    }

    validateField(field, rule, data, value, valid) {
        let errors = [];
        let hasValidationKey = this.ruleKeys.some(key => Object.keys(rule).includes(key));
        if(value instanceof Array && !hasValidationKey) {
            let childErrors = value.map(childValue => {
                let errorObject = {}
                Object
                .keys(rule)
                .forEach(key => {
                    let { isValid, errors } = this.validateField(key, rule[key], childValue, childValue[key], valid)
                    valid = isValid;
                    errorObject[key] = errors;
                })
                return errorObject;
            })
            if(childErrors) errors.push(...childErrors);
        } else {
            Object
            .keys(rule)
            .forEach(key => {
                let val = value === null || value === undefined ? '' : value;
                let error = this.checkFieldError(rule, key, data, val);
                if(error && error instanceof Array) {
                    valid = false;
                    errors = errors.concat(error);
                } else if(error) {
                    valid = false;
                    errors.push(error);
                }
            })
        }

        return {
            isValid: valid,
            errors: errors.length > 0 ? errors : null
        };
    }
    
    validateData(rules, data) {
        let fields = {};
        let valid = true

        Object
        .keys(rules)
        .forEach(key => {
            let { isValid, errors } = this.validateField(key, rules[key], data, data[key], valid)
            fields[key] = errors;
            valid = isValid;
        });

        return {
            valid,
            fields
        }            
    }
}

export default new Validation();